<template>
	<div
		class="rounded-circle"
		:class="additionalClasses"
		:style="styleObj"
	></div>
</template>

<script>
export default {
	name: "RadioCircle",
	props: {
		active: Boolean,
		colorDefault: {
			type: String,
			default: "black",
		},
		colorActive: {
			type: String,
			default: "black",
		},
		size: {
			type: String,
			default: "20px",
		},
		borderSizeDefault: {
			type: String,
			default: "2px solid",
		},
		borderSizeActive: {
			type: String,
			default: "4px solid",
		},
		transition: {
			type: String,
			default: "border 100ms ease-in-out",
		},
		additionalClasses: {
			type: String,
			default: "",
		},
		backgroundDefault: {
			type: String,
			default: "transparent",
		},
		backgroundActive: {
			type: String,
			default: "transparent",
		},
	},
	computed: {
		styleObj() {
			return {
				height: this.size,
				width: this.size,
				minHeight: this.size,
				minWidth: this.size,
				border: this.active ? this.borderSizeActive : this.borderSizeDefault,
				color: this.active ? this.colorActive : this.colorDefault,
				transition: this.transition,
				background: this.active
					? this.backgroundActive
					: this.backgroundDefault,
			};
		},
	},
};
</script>

<style scoped></style>
